export default __webpack_public_path__ + "content/d2456b7eecbc124e6be42343636b01f1.svg";